import React from "react";
import { Link } from "react-router-dom";
import ScrollReveal from "../components/ScrollReveal";
import { getCopy, getCopyObject } from "../utils/copyUtils";

interface HelpItem {
  title: string;
  description: string;
  icon: string;
}

const AboutPage: React.FC = () => {
  // Get copy from JSON file
  const heroData = getCopyObject<{ title: string; description: string }>("about.hero");
  const storyData = getCopyObject<{ title: string; paragraphs: string[] }>("about.story");
  const helpData = getCopyObject<{ title: string; items: HelpItem[] }>("about.how_we_help");
  const visionData = getCopyObject<{ title: string; paragraphs: string[] }>("about.global_vision");
  const ctaData = getCopyObject<{ title: string; description: string; link_text: string }>("about.cta");

  return (
    <>
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <ScrollReveal className="hero-content" direction="up" delay={200}>
            <h1 className="hero-title">{heroData?.title}</h1>
            <p className="hero-description">{heroData?.description}</p>
          </ScrollReveal>
        </div>
      </section>

      <main className="main">
        <div className="main__curved curved-ellipse"></div>
        <div className="main__curved-line curved-ellipse"></div>

        {/* foundation Section */}
        <section className="foundation">
          <div className="foundation-container container">
            <ScrollReveal direction="up" delay={200}>
              <h3 className="foundation__title_mobile title">{storyData?.title}</h3>
            </ScrollReveal>

            <ScrollReveal className="foundation__image" direction="right" delay={300}>
              <img src="/images/about/foundation-logo.svg" alt="foundation logo" />
            </ScrollReveal>
            <ScrollReveal className="foundation__content" direction="left" delay={400}>
              <h3 className="foundation__title title">{storyData?.title}</h3>
              {storyData?.paragraphs.map((paragraph, index) => (
                <p key={index} className="foundation__text text">
                  {paragraph}
                </p>
              ))}
            </ScrollReveal>
          </div>
        </section>

        {/* helps Section */}
        <section className="helps">
          <div className="helps-container container">
            <ScrollReveal direction="up" delay={200}>
              <h3 className="helps__title title">{helpData?.title}</h3>
            </ScrollReveal>
            <ul className="helps__list">
              {helpData?.items.map((item, index) => (
                <ScrollReveal key={index} className="helps__item" direction="up" delay={300 + index * 100}>
                  <div className="helps__item-icon">
                    <img src={item.icon} alt={item.title} />
                  </div>
                  <div className="helps__item-content">
                    <h4 className="helps__item-content-title">{item.title}</h4>
                    <p className="helps__item-content-description text">{item.description}</p>
                  </div>
                </ScrollReveal>
              ))}
            </ul>
          </div>
        </section>

        <section className="global-vision">
          <div className="global-vision-container container">
            <ScrollReveal className="global-vision__image" direction="right" delay={200}>
              <img src="/images/about/global-vision.svg" alt="global-vision" />
            </ScrollReveal>
            <ScrollReveal className="global-vision__content" direction="left" delay={300}>
              <h4 className="global-vision__title title">{visionData?.title}</h4>
              <div className="text">
                {visionData?.paragraphs.map((paragraph, index) => (
                  <p key={index} dangerouslySetInnerHTML={{ __html: paragraph }} />
                ))}
              </div>
            </ScrollReveal>
          </div>
        </section>

        <section className="future">
          <div className="future-container container">
            <ScrollReveal direction="up" delay={200}>
              <h3 className="future__title title">{ctaData?.title}</h3>
              <p className="future__text">
                <span className="text">{ctaData?.description}</span>

                <div className="mt-30">
                  <Link to="/book-demo" className="btn btn-primary">
                    {ctaData?.link_text}
                  </Link>
                </div>
              </p>
            </ScrollReveal>
          </div>
        </section>
      </main>
    </>
  );
};

export default AboutPage;
